module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"price":"Price","mileage":"Mileage","search_placeholder":"Search by Make, Model, Stock, Vin","no_result":"No cars found."},"es":{"price":"Precio","search_placeholder":"Búsqueda por Marca, Model, Stock, Vin","no_result":"No se encontraron resultados.","mileage":"Millas"}}')
  delete Component.options._Ctor
}
